export const primary = "#1890FF"